<template>
  <div>
    <div
      @click="showCont"
      id="mapChart"
      ref="mapChart"
      style="position: absolute; width: 100%; height: 100%"
    ></div>
    
    <div v-if="show" class="head-div3">
      <table border="0px" class="head-table">
        <tr style="font-size: 12px; font-weight: bold;border-bottom: 1px solid white;width: 100%">
          <td>{{ carData.schoolName[0].name }}</td>
          <td>{{ carData.pathName.path_name }}</td>
          <td>
            {{ carData.carTime.depart_time}}发车
          </td>
          <td>
            准载{{ carData.personNum.bus_accurate_load_number }}人
          </td>
          <td>
            限速{{ carData.pathName.max_speed }}km/h
          </td>
        </tr>
        <tr style="font-size: 11px;width: 100%">
          <td>● 校车司机</td>
          <td colspan="2">{{ carData.driverContact.name }}</td>
          <td colspan="2">{{ carData.driverContact.mobile }}</td>
        </tr>
        <tr style="font-size: 11px;width: 100%">
          <td>● 跟车老师</td>
          <td colspan="2">{{ carData.teacherContact.name }}</td>
          <td colspan="2">{{ carData.teacherContact.mobile }}</td>
        </tr>
        <tr style="font-size: 11px;width: 100%">
          <td>● 乘车孩子</td>
          <td colspan="2">
              <template v-for="(name, index) in carData.childName">
                {{(index==carData.childName.length-1)? name.name:name.name+"," }}
              </template>

          </td>
          
        </tr>
      </table>
    </div>
    <div class="head-div4" id="myMarker">
    

    </div>
  </div>
</template>

<script>
let marker;
var polyline;
// 点标记显示内容，HTML要素字符串
var markerContent =
  "" +
  '<div class="custom-content-marker">' +
  '   <img src="//a.amap.com/jsapi_demos/static/demo-center/icons/dir-via-marker.png">' +
  '   <div class="close-btn" onclick="clearMarker()">X</div>' +
  "</div>";

export default {
  name: "OpsMarket",
  data() {
    return {
      msg: "",
      isshow: false,
      map: null,
      mass: null,
      timeid:null,
      //校车数据
      carData: {
        carTime: {
          depart_time: null,
        },
        childName: [
          {
            name: null,
          },
        ],
        driverContact: {
          mobile: null,
          name: null,
        },
        pathName: {
          path_name: null,
          max_speed: null,
        },
        personNum: {
          bus_accurate_load_number: null,
        },
        schoolName: [(name = null)],
        teacherContact: {
          name: null,
          mobile: null,
        },
      },
      // style: [
      //   "//a.amap.com/jsapi_demos/static/demo-center/icons/poi-marker-default.png", // 标记样式图片1
      //   "//a.amap.com/jsapi_demos/static/demo-center/icons/poi-marker-red.png", // 标记样式图片2
      // ],
      // list: [
      //   {
      //     adcode: "330000",
      //     name: "山东省",
      //     center: [117.019915, 36.671156],
      //   },
      //   {
      //     adcode: "330003",
      //     name: "山东省",
      //     center: [117.018918, 36.671156],
      //   },
      //   {
      //     adcode: "330003",
      //     name: "山东省",
      //     center: [117.017918, 36.671156],
      //   },
      // ],
      imgUrl1: require("../../assets/bus.png"),
      imgUrl2: require("../../assets/busupdiv.png"),
      imgUrl3: require("../../assets/weidaozhan.png"),
      show: false,
    };
  },
  created() {
    var url =
      "https://webapi.amap.com/maps?v=1.4.15&key=1ed00c427a64f647fc7a3809dff30426&plugin=AMap.Driving&callback=onLoad";
    var jsapi = document.createElement("script");
    jsapi.charset = "utf-8";
    jsapi.src = url;
    document.head.appendChild(jsapi);
    // var url1 =
    //   'https://webapi.amap.com/maps?v=1.4.15&key=1ed00c427a64f647fc7a3809dff30426&plugin=AMap.Driving'
    // var jsapi1 = document.createElement('script')
    // jsapi1.charset = 'utf-8'
    // jsapi1.src = url1
    // document.head.appendChild(jsapi1)
  },
  mounted() {
    this.mapFn();
    // this.get();
  },

  methods: {
    //点击地图信息框显示隐藏
    showCont: function () {
      // this.show = false;
    },
    intervalInit() {
      if(!this.timeid){
        this.timeid = setInterval(() => {
          this.updateDate();
      }, 10000)
      }
    },
    showSitePatn(pathDate) {
      var that = this;
      //插点
      //
      var classname = pathDate.nohaveWarning ? "busupdivimg" : "busupdivimgred";
      var markerContent =
        "" +
        '<div class="custom-content-marker" style="text-align: left;color:white;" >' +
        // '   <div class="' +
        // classname +
        // '" style="width:125px;height: 75px;text-align: left;padding-top: 3px;padding-left: 6px;font-size: 10px;">' +
        // '<span>' +
        // (pathDate.busSchool ? pathDate.busSchool.name.substring(0, 11) : '') +
        // '</span><br/><span>' +
        // '(' +
        // pathDate.busCode +
        // ')' +
        // '</span><br/><span>当前人数：' +
        // pathDate.studentCount +
        // ' 人' +
        // '</span><br/><span>当前车速：' +
        // pathDate.speed +
        // ' km/h' +
        // '</span></div>' +
        '   <img src="' +
        this.imgUrl1 +
        '" style="width:45px;">' +
        "</div>";

      var markerDistance =
        "" +
         '<div class="custom-content-marker"  style="text-align: left;color:white;">' +
        // '   <div class="' +
        // classname +
        // '" style="width:125px;height: 75px;text-align: left;padding-top: 5px;padding-left: 6px;font-size: 10px;">' +
        // '<span>' +
        // (pathDate.busSchool ? pathDate.busSchool.name.substring(0, 11) : '') +
        // '</span><br/><span>' +
        // '(' +
        // pathDate.busCode +
        // ')' +
        // '</span><br/><span>当前人数：' +
        // pathDate.studentCount +
        // ' 人' +
        // '</span><br/><span>当前车速：' +
        // pathDate.speed +
        // ' km/h' +
        // '</span></div>' +
        '   <img src="' +
        this.imgUrl1 +
        '" style="width:45px;">' +
        "</div>";

      // var markerDistance = new AMap.Marker({
      //   position: new AMap.LngLat(116.99741, 36.65101),
      //   offset: new AMap.Pixel(-10, -10),
      //   icon: '//vdata.amap.com/icons/b18/1/2.png', // 添加 Icon 图标 URL
      //   title: '北京',
      // })

      // this.map.add(markerDistance)
      var _this = this;
      marker = new AMap.Marker({
        map: this.map,
        position: pathDate.beidouLocation,
        content: markerContent,
        content: markerDistance,
        offset: new AMap.Pixel(-30, -20),
        autoRotation: true,
        angle: 0,
        extData: pathDate,
      });
      // marker2 = new AMap.Marker({
      //   map: this.map,
      //   position: pathDate.beidouLocation,
      //   content: markerDistance,
      //   offset: new AMap.Pixel(-50, -110),
      //   autoRotation: true,
      //   angle: 0,
      //   extData:pathDate
      // });

      //点击校车信息框出现/隐藏
      var clickHandle = AMap.event.addListener(marker, "click", function (e) {
        var busData = JSON.parse(JSON.stringify(e.target.getExtData()));

        console.log(busData);
        console.log(JSON.parse(localStorage.getItem("userInfo")));
        that.getSchoolCarOfficialList(
          busData.busId,
          JSON.parse(localStorage.getItem("userInfo")).patriarchUserId,
          busData.schoolId
        );
         _this.show = !_this.show;
         this.cur = JSON.parse(JSON.stringify(e.target.getExtData()));
        //得到的数据
      });

      //划线
      var lineArr = pathDate.beidouLocationList;

      // [[117.157586,36.747129],[117.152458,36.744825],[117.146772,36.74443],[117.146128,36.738996],
      //     [117.145828,36.733579],[117.146042,36.729074],[117.146107,36.726821],[117.146364,36.720388],[117.146343,36.720405],[117.138339,36.720165],
      //     [117.138618,36.716346],[117.146399,36.716871],[117.147008,36.708468],[117.146965,36.702275],[117.14748,36.693638],[117.138017,36.689061],
      //     [117.129992,36.68531],[117.135657,36.67736],[117.131494,36.675415]]  

      // 绘制轨迹
      polyline = new AMap.Polyline({
        map: this.map,
        path: lineArr,
        showDir: true,
        strokeColor: "#28F", //线颜色
        // strokeOpacity: 1,     //线透明度
        strokeWeight: 6, //线宽
        // strokeStyle: "solid"  //线样式
      });

      //插入站点
      var markcon =
        '<div class="custom-content-marker" style="text-align: left;">'   +
        '   <div id="markcon" style="text-align: center;color: rgb(250, 250, 250);visibility: hidden;width: max-content;padding: 0px 10px;background-color: rgb(64, 158, 255);/* font-weight: 900; */font-size: 10px;border-radius: 4px;padding: 3px;"> 齐鲁软件园<br/>2 </div>' +
        '   <img style="width: auto;" src=' +
        this.imgUrl3 +
        ">" +
        "</div>";
      var markerone = new AMap.Marker({
        map: this.map,
        position: [117.131002, 36.675243],
        content: markcon,
        offset: new AMap.Pixel(-10, -55),
        autoRotation: true,
        angle: 0,
      });

      console.log(AMap.DrivingPolicy);
      var drivingOption = {
        policy: AMap.DrivingPolicy.LEAST_TIME, // 其它policy参数请参考 https://lbs.amap.com/api/javascript-api/reference/route-search#m_DrivingPolicy
        ferry: 1, // 是否可以使用轮渡
        province: "京", // 车牌省份的汉字缩写
      };
      var driving = new AMap.Driving(drivingOption);
      //markerone.on('click', function (e) {
      this.isshow = !this.isshow;
      if (this.isshow) {
        var showhtml = "";
        //获取两点距离
        //根据起终点经纬度规划驾车导航路线
        driving.search(
          new AMap.LngLat(
            pathDate.beidouLocation[0],
            pathDate.beidouLocation[1]
          ),
          new AMap.LngLat(117.131002, 36.675243),
          function (status, result) {
            // result即是对应的驾车导航信息， 相关数据结构文档请参考 https://lbs.amap.com/api/javascript-api/reference/route-search#m_DrivingResult
            console.log(result);
            let a = Date.now();
            a+=result.routes[0].time*1000
            let ndatre=new Date(a)
            showhtml =
              "距离" +
              (result.routes[0].distance / 1000).toFixed(2) +
              "km，约" +
              ndatre.getHours().toString()+':'+ndatre.getMinutes().toString().padStart(2, "0")+
              "到";
            var div = document.getElementById("markcon");
            div.innerHTML = "齐鲁软件园" ;
            div.style.visibility = "visible";
            var myMarkerDiv = document.getElementById("myMarker");
            myMarkerDiv.innerHTML = "<div style='margin:10px'>距齐鲁软件园站 " + (result.routes[0].distance / 1000).toFixed(2) +" km，约 " +
              ndatre.getHours().toString()+':'+ndatre.getMinutes().toString().padStart(2, "0")+
              " 到达</div>";
          }
        );
      } else {
        var div = document.getElementById("markcon");
        div.style.visibility = "hidden";
      }
      //})
      var sanjiao=[lineArr[0],lineArr[lineArr.length-1],{"Q":"36.675243","lat":"36.675243","R":"117.131002","lng":"117.131002"}]
      //1.把想自适应的部分的点装在一个透明的覆盖物图层里
      var polygon = new AMap.Polygon({
        path: sanjiao, //以5个点的坐标创建一个隐藏的多边形
        map: this.map,
        strokeOpacity: 0, //透明
        fillOpacity: 0, //透明
        bubble: true, //事件穿透到地图
      });
      var overlaysList = this.map.getAllOverlays("polygon"); //获取多边形图层

      //2.使用setFitView方法
      this.map.setFitView(overlaysList); //自适应显示
    },
    updateSitePatn(pathDate) {
        		//插点
        var markerContent1 ="" +
        '<div class="custom-content-marker" style="text-align: left;color:white;" >' +
        '   <img src="' +
        this.imgUrl1 +
        '" style="width:45px;">' +
        "</div>";
        marker.setContent(markerContent1); //更新点标记内容
        marker.setPosition(pathDate.beidouLocation); //更新点标记位置
		
		//点击校车信息框出现/隐藏
		  var clickHandle = AMap.event.addListener(marker, "click", function (e) {
			var busData = JSON.parse(JSON.stringify(e.target.getExtData()));
			console.log(busData);
			this.getSchoolCarOfficialList(
			  busData.busId,
			  JSON.parse(localStorage.getItem("userInfo")).patriarchUserId,
			  busData.schoolId
			);  
			 _this.show = !_this.show;
			 this.cur = JSON.parse(JSON.stringify(e.target.getExtData()));
			//得到的数据
		  });

      //划线
      var lineArr = pathDate.beidouLocationList
      // 绘制轨迹
      polyline = new AMap.Polyline({
        map: this.map,
        path: lineArr,
        showDir: true,
        strokeColor: "#28F", //线颜色
        // strokeOpacity: 1,     //线透明度
        strokeWeight: 6, //线宽
        // strokeStyle: "solid"  //线样式
      });

        //插入站点
      var markcon =
        '<div class="custom-content-marker" style="text-align: left;">' +
        '   <div id="markcon" style="text-align: center;color: rgb(250, 250, 250);visibility: hidden;width: max-content;padding: 0px 9px;background-color: rgb(64, 158, 255);/* font-weight: 900; */font-size: 10px;border-radius: 3px;padding: 3px;">  齐鲁软件园 <br/>2 </div>' +
        '   <img style="width: auto;" src=' +
        this.imgUrl3 +
        ">" +
        "</div>";
      var markerone = new AMap.Marker({
        map: this.map,
        position: [117.131002, 36.675243],
        content: markcon,
        offset: new AMap.Pixel(-10, -65),
        autoRotation: true,
        angle: 0,
      });

      console.log(AMap.DrivingPolicy);
      var drivingOption = {
        policy: AMap.DrivingPolicy.LEAST_TIME, // 其它policy参数请参考 https://lbs.amap.com/api/javascript-api/reference/route-search#m_DrivingPolicy
        ferry: 1, // 是否可以使用轮渡
        province: "京", // 车牌省份的汉字缩写
      };
      var driving = new AMap.Driving(drivingOption);
      var showhtml = "";
      //获取两点距离
      //根据起终点经纬度规划驾车导航路线
      driving.search(
        new AMap.LngLat(
          pathDate.beidouLocation[0],
          pathDate.beidouLocation[1]
        ),
        new AMap.LngLat(117.131002, 36.675243),
        function (status, result) {
          // result即是对应的驾车导航信息，相关数据结构文档请参考 https://lbs.amap.com/api/javascript-api/reference/route-search#m_DrivingResult
          console.log(result);
          let a = Date.now();
          a+=result.routes[0].time*1000
          let ndatre=new Date(a)
          showhtml =
            "距离" +
            (result.routes[0].distance / 1000).toFixed(2) +
            "km，约" +
            ndatre.getHours().toString()+':'+ndatre.getMinutes().toString().padStart(2, "0")+
            "到";
          var div = document.getElementById("markcon");
          div.innerHTML = "齐鲁软件园";
          div.style.visibility = "visible";
          var myMarkerDiv = document.getElementById("myMarker");
            myMarkerDiv.innerHTML = "<div style='margin:10px'>距齐鲁软件园站 " + (result.routes[0].distance / 1000).toFixed(2) +" km，约 " +
              ndatre.getHours().toString()+':'+ndatre.getMinutes().toString().padStart(2, "0")+
              " 到达</div>";
        }
      );
    }, 
    getData() {
      this.axios
        .get("student-consumer/api/schoolBus/getBusRrealTimeData")
        .then((res) => {
          if (res.code === 200) {
            if (res.data && res.data.length > 0) {
              let dataarr = res.data;
              console.log(dataarr);
              for (let index = 0; index < dataarr.length; index++) {
                let element = dataarr[index];
                //   //获取车速
                //   console.log('speed:=>',res);
                //   this.axios.get("student-consumer/api/schoolcarofficial/getSchoolCarOfficialBusList?busId="+dataarr[index].busId).then(res=>{
                //     console.log('speed:=>',res);
                //     if(res.data&&res.data[1]){
                //       element.speed=res.data[1].speed;
                //     }
                // })
                this.showSitePatn(element);
              }
              // console.log(this.map.getZoom())
              // this.map.setZoomAndCenter(this.map.getZoom()+2,this.map.getCenter())
              // console.log(this.map.getZoom())
            }
          } else {
            message.warning(res.msg);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    updateDate(){
        this.axios.get('student-consumer/api/schoolBus/getBusRrealTimeData')
            .then(res => {
                if (res.code === 200) {
                    if (res.data && res.data.length > 0) {
                        let dataarr = res.data
                        for (let index = 0; index < dataarr.length; index++) {
                            let element = dataarr[index]
                            this.updateSitePatn(element)
                        }
                    }
                } else {
                    message.warning(res.msg)
                }
            })
            .catch(err => {
                console.log(err)
            })
    },


    //根据校车id获取校车详细信息
    getSchoolCarOfficialList(busId, parentId, schoolId) {
      var that = this;
      var params = {
        busId: busId,
        parentId: parentId,
        schoolId: schoolId,
      };
      that.axios
        .get(
          "student-consumer/api/schoolcarofficial/getSchoolCarOfficialList?busId=" +
            busId +
            "&parentId=" +
            parentId +
            "&schoolId=" +
            schoolId
        )
        .then((res) => {
          console.log(res);
          if (res.code === 200) {
            that.carData = res.data[0];
            //console.log(that.carData);
            // if (res.data && res.data.length > 0) {
            //   var childNames=[];
            //   for(var index=0;index<res.data.length;index++){
            //     childNames.push(res.data.childName);
            //   }
            //   that.carData=res.data;
            //   that.carData.childNames=childNames;
            // }
          } else {
            message.warning(res.msg);
          }
        });
    },

    mapFn() {
      var _this = this;
      window.onLoad = function () {
        // 创建地图，同时给地图设置中心点、级别、显示模式、自定义样式等属性
        _this.map = new AMap.Map("mapChart", {
          resizeEnable: true,
        });
        AMap.plugin([
            'AMap.ToolBar',
        ], function(){
            // 在图面添加工具条控件，工具条控件集成了缩放、平移、定位等功能按钮在内的组合控件
            _this.map.addControl(new AMap.ToolBar({
                // 简易缩放模式，默认为 false
                liteStyle: true
            }));
        });
        // _this.map.setFitView(); 
        _this.getData();
        _this.intervalInit()
      };
    },
  },
};
</script>
<style lang="scss">
.amap-icon img,
.amap-marker-content img {
  width: 19px;
  height: 27px;
}

.marker {
  position: absolute;
  top: -20px;
  right: -118px;
  color: #fff;
  padding: 4px 10px;
  box-shadow: 1px 1px 1px rgba(10, 10, 10, 0.2);
  white-space: nowrap;
  font-size: 12px;
  font-family: "";
  background-color: #25a5f7;
  border-radius: 3px;
}

.input-card {
  width: 18rem;
  z-index: 170;
}

.input-card .btn {
  margin-right: 0.8rem;
}

.input-card .btn:last-child {
  margin-right: 0;
}
.busupdivimg {
  background: url(../../assets/busupdiv.png) no-repeat;
  background-size: 100% 100%;
}
.busupdivimgred {
  background: url(../../assets/busupdivred.png) no-repeat;
  background-size: 100% 100%;
}

.head-div3 {
  position: absolute;
  top: 2%;
  left: 3%;
  width: 94%;
  height: auto;
  border-radius: 4px;
  opacity: 0.8;
  background: #1573df;
  
}
.head-table {
  margin: 10px 5px;
  width: 340px;
  height: 115px;
  color: white;
  text-align: center;
}
.head-div4 {
  position: absolute;
  bottom: 5%;
  left: 14%;
  width: 70%;
  height: auto;
  font-size: 12px; 
  text-align: center;
  background: #1573df;
  border-radius: 4px;
  opacity: 0.8;
  color: white;
}
</style>
